import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { CookiePolicyService } from 'types/next';

interface ContentProps {
  contentData: CookiePolicyService;
}

const CookiePolicy = ({ contentData }: ContentProps) => {
  const [cookies, setCookie] = useCookies(['locale_selection', 'frontastic-session']);
  const [termlyScriptId, setTermlyScriptID] = useState(
    cookies?.locale_selection?.currency === 'GBP' ? contentData?.termlyScriptId?.uk : contentData?.termlyScriptId?.eu,
  );

  //   const termlyScriptId = ;
  useEffect(() => {
    setTermlyScriptID(
      cookies?.locale_selection?.currency === 'GBP' ? contentData?.termlyScriptId?.uk : contentData?.termlyScriptId?.eu,
    );
  }, [cookies?.locale_selection?.currency]);

  useEffect(() => {
    // Re-run the embed initialization after the div is present
    if (typeof window !== 'undefined') {
      const existingScript = document.getElementById('termly-jssdk');
      if (existingScript) {
        existingScript.remove();
      }

      const js = document.createElement('script');
      js.id = 'termly-jssdk';
      js.src = 'https://app.termly.io/embed-policy.min.js';
      document.body.appendChild(js);
    }
  }, [termlyScriptId]); // Trigger whenever ID changes

  return (
    <div
      data-id={termlyScriptId}
      ref={(el) => {
        if (el) el.setAttribute('name', 'termly-embed');
      }}
    ></div>
  );
};

export default CookiePolicy;
